var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignmentLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.848,
    height: 12.773,
    viewBox: "0 0 8.848 12.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_81e98e3a69bdb6690515c719833a59fa",
    "data-name": "81e98e3a69bdb6690515c719833a59fa",
    d: "M5,3V14.773M9.578,6.924,7.616,8.886m0,0,1.962,1.962M7.616,8.886h5.232",
    transform: "translate(-4.5 -2.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignmentLeft);
export default __webpack_public_path__ + "static/media/alignment-left.3f8bd76464702aae7553df29bd4f3fca.svg";
export { ForwardRef as ReactComponent };